// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sm-1";
export var stateContainer = "_sm-0";